var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"m-blog"},[_c('y-container',[_c('y-blog-hero',{on:{"hero-content":_vm.getHeroContent}}),_c('y-popular-articles')],1),_c('y-categories',{attrs:{"has-categories":""}}),_c('y-container',[_c('y-email-subscription')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }